<template>
<div class="panel stock-list">
  <div class="panel-heading text-force-align">
    <div class="text-right">
      登録したアカウント
    </div>
    <div class="text-left" v-if="is_show_edit_button">
      <b-icon icon="edit" style="margin-left:1em;"
        v-bind:type="{'is-danger': is_edit}"
        @click.native="is_edit = !is_edit;">
      </b-icon>
    </div>
  </div>
  <router-link class="panel-block text-force-align"
    v-for="lst in following_list" :key="lst.id"
    :to="(is_edit) ? '' : '/likes_followed_log/'+lst.id">
        <figure class="dropdown-trigger image is-32x32" style="float: left; margin-right:0.5em;">
          <img class="is-rounded" v-bind:src="lst.profile_image_url">  <!-- twitterアイコン -->
        </figure>
      {{lst.name}}
        <span class="is-size-6 has-text-grey-light">
          @{{lst.screen_name}}
        </span>
    <p class="text-left">
      <a class="button is-rounded is-small is-danger" v-if="is_edit"
         @click="removeFollowAccount(lst.id, lst.name)">
        <b-icon icon="minus" size="is-small"></b-icon>
      </a>
    </p>
  </router-link>
  <label class="label" style="margin-top:1em;" v-if="is_edit">
    追加するアカウントのID
  </label>
  <b-field v-if="is_edit">
    <b-input placeholder="例：@interimadd" v-model="add_account_name" expanded></b-input>
    <p class="control">
      <span class="button is-success" @click="addFollowAccount()">追加</span>
    </p>
  </b-field>
</div>
</template>

<script>
export default {
  title: "- 登録したアカウント",
  data() {
    return {
      /*
      following_list: [
        {
          id: '547627859',
          screen_name: 'interimadd',
          name: 'みがわり',
          profile_image_url: 'http://pbs.twimg.com/profile_images/665729290000994304/AOR75xyC_normal.png'
        }
      ], */
      add_account_name: "",
      is_edit: false,
    }
  },
  props: {
    is_show_edit_button: {
      type: Boolean,
      default: true,
    }
  },
  computed: {
    following_list: function () {
      return this.$store.getters['getLikeFollowUsers']
    }
  },
  mounted() {
    if(this.following_list.length == 0) this.is_edit = true
  },
  methods: {
    async addFollowAccount() {
      const accountName = this.add_account_name.replace("@", "")
      this.add_account_name = ""
      this.$buefy.toast.open({
        message: 'アカウントの追加には時間がかかります<br>しばらくお待ちください',
      })
      const is_sucess = await this.$store.dispatch("addFollowUserByScreenName", accountName)
      if(is_sucess == true){
        this.$buefy.toast.open('アカウントを追加しました！')
      }
      else{
        this.$buefy.toast.open('アカウントを追加できませんでした')
      }
    },
    async removeFollowAccount(userId, userName) {
      this.$buefy.dialog.confirm({
        message: `本当に「${userName}」の登録を解除しますか？`,
        cancelText: 'キャンセル',
        confirmText: '解除する',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          this.$store.dispatch("removeFollowUser", userId)
        }
      })
    }
  }
}
</script>

<style scoped>
.stock-list { max-width: 800px;}

@media screen and (min-width: 1100px){
  .stock-list{ 
    max-width: 800px;
    margin-top: 20px;
  }
}

.text-force-align { display: table; width: 100%;}
.text-right { display: table-cell; text-align: left; }
.text-center  { display: table-cell; text-align: center; }
.text-left     { display: table-cell; text-align: right; }
</style>